import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';
import { Button } from '@iwoca/orion';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import messages from './TopUpEligible.messages';
import styles from '../DashboardActions.module.css';
import { connect } from 'react-redux';
import * as selectors from '../../../accountsSelector';
import { RootState } from '@iwProvider/configureStore';
import { TopupEligibleSVG } from '@svgComponents/TopupEligibleSVG/TopupEligibleSVG';
import { Dispatch } from 'redux';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';
import { MoneyNoDecimals } from '../../../../../myAccount/ui/moneyNoDecimals';

const mapStateToProps = (state: RootState) => {
    const productType = selectors.getProductTypeFromURL();

    return {
        isFlexi24:
            getCountry() === 'UK' &&
            selectors.getProductTypeFromURL() ===
                selectors.FLEXI_24_PRODUCT_TYPE,
        isTopUpPending: selectors.isTopUpPending(state, productType),
        accountId: selectors.getAccountId(state, productType),
        isPreApproved: selectors.isPreApproved(state, productType),
        latestFormalOfferAmount: selectors.getMaxCashAmount(state, productType)
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToApplyFlexiLoanForm: (isFlexi24: boolean) =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/apply-flexi-loan/',
                search: isFlexi24
                    ? '?topup=true&product_type=flexi24'
                    : '?topup=true'
            }
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type Props = {
    className?: string;
} & PropsFromRedux &
    WrappedComponentProps;

const TopUpEligible = ({
    goToApplyFlexiLoanForm,
    isFlexi24,
    className,
    accountId,
    isPreApproved,
    latestFormalOfferAmount
}: Props) => {
    const handleRequestTopUp = () => {
        tracking.ampli.topupRequestStarted({
            account_id: accountId
        });
        tracking.ampli.requestMoreFundsClicked({
            account_id: accountId
        });

        goToApplyFlexiLoanForm(isFlexi24);
    };

    return (
        <DashboardCTA
            data-testid="top-up-eligible-action"
            title={
                isPreApproved ? (
                    <FormattedMessage
                        {...messages.preApprovedTitle}
                        values={{
                            preApprovedAmount: (
                                <MoneyNoDecimals
                                    value={latestFormalOfferAmount}
                                />
                            )
                        }}
                    />
                ) : (
                    <FormattedMessage {...messages.title} />
                )
            }
            className={className}
            icon={<TopupEligibleSVG />}
            description={
                isPreApproved ? (
                    <FormattedMessage {...messages.preApprovedDescription} />
                ) : (
                    <FormattedMessage {...messages.description} />
                )
            }
            cta={
                <Button
                    data-testid="top-up-action-button"
                    variant="primary"
                    onClick={handleRequestTopUp}
                    className={styles.dashboardActionCTA}
                >
                    <FormattedMessage {...messages.ctaText} />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(TopUpEligible));
